import * as Sentry from '@sentry/react';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import RefreshPage from 'src/components/RefreshModal/RefreshPage';
import { dispatch } from 'src/redux/config/configureStore';
import { RootState } from 'src/redux/config/rootReducer';
import { openDialog } from 'src/redux/slices/dialogs.slice';
import { DialogType } from 'src/redux/types/redux.types';

const UserActivity = ({ timeout }) => {
  const { user } = useSelector((state: RootState) => state.user);

  // Use let to declare these variables so they can be accessed globally
  let intervalCheckActivity;
  let activated = false;

  //setting the user for the remote logging
  useEffect(() => {
    if (user) {
      Sentry.setUser({
        email: user.email,
      });
    }
  }, [user]);

  /***
   * @description reseting the user activity state
   */
  const resetUserActivity = () => {
    // Clear the existing intervals
    clearInterval(intervalCheckActivity);

    // Restart the intervals
    startIntervals();
  };

  /***
   * @description when the user has ben inactive
   */
  const userHasBeenInactive = () => {
    handleInactivity();
    clearInterval(intervalCheckActivity);
    activated = true;
  };

  /**
   * @description starting the timers to see the amount of inactivity
   */
  const startIntervals = () => {
    intervalCheckActivity = setInterval(() => {
      userHasBeenInactive();
    }, timeout); //2 hours
  };

  /***
   * @description reseting the user activity state on mouse move or key press
   */
  useEffect(() => {
    startIntervals();

    const handleResetUserActivity = () => {
      if (!activated) resetUserActivity();
    };

    // Event listeners to track user activity
    document.addEventListener('mousedown', handleResetUserActivity);
    document.addEventListener('keydown', handleResetUserActivity);

    // Cleanup event listeners on component unmount
    return () => {
      document.removeEventListener('mousedown', handleResetUserActivity);
      document.removeEventListener('keydown', handleResetUserActivity);
    };
  }, []);

  /**
   * @description showing the inactivity modal
   */
  const handleInactivity = () => {
    dispatch(
      openDialog({
        hideX: true,
        type: DialogType.Custom,
        header: ``,
        content: <RefreshPage />,
      }),
    );
  };

  return null;
};
export default UserActivity;
